import { useEffect, useState , useContext} from "react";
import {
  Container,
  Box,
  Breadcrumbs,
  Flex,
  Text,
  Paper,
  Table,
  ActionIcon,
  useMantineTheme,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { IconShoppingCart, IconTrash } from "@tabler/icons-react";
import { api } from "../services/master.service";
import { is_mobile_view } from "../config";
import { Link, useNavigate } from "react-router-dom";
import { qtyCalculator } from "../utilities/Common";  // ✅ same as Cart.js
import { showSuccessToast, showErrorToast } from "../utilities/Toast";
import { CartContext } from "../App";


export default function NotifyPage() {
  let isMobileScreen = useMediaQuery("(max-width: 768px)");
  isMobileScreen = is_mobile_view ? is_mobile_view : isMobileScreen;
  const theme = useMantineTheme();

  const [notifyList, setNotifyList] = useState([]);

  const { setCartItemCount } = useContext(CartContext);
  
  const navigate = useNavigate();

const addToCart = async (item) => {
  await api.add_to_cart({
    product_id: item.product_id,
    quantity: qtyCalculator(1, 1, item.varientUnit, item.isVarient), // ✅ default 1 quantity
    varientSlug: `${1}${item.isVarient ? item.varientUnit : "pkt"} x 1`,
  }).then((res) => {
    console.log(res.data);
    if (res.data.success) {
      setCartItemCount(res.data.data?.cartitem.length);
      showSuccessToast({
        title: "Success",
        message: "Item successfully added to cart.",
      });
    } else {
      if (res.data.code === 401) {
        navigate("/login");
        showErrorToast({
          title: "Warning",
          message: "You have to login to add items to cart.",
        });
      } else {
        showErrorToast({
          title: "Error",
          message: res.data.message,
        });
      }
    }
  });
};



  useEffect(() => {
    api.get_notify_list().then((res) => {
      if (res.success) {
        setNotifyList(res.data);
      } else {
        alert(res.message);
      }
    });
  }, []);

  const handleDelete = (id) => {
    api.delete_notify(id).then((res) => {
      if (res.success) {
        setNotifyList((prev) => prev.filter((item) => item.id !== id));
      } else {
        alert(res.message);
      }
    });
  };

  return (
    <div>
      <Container
        size={"xl"}
        fluid={isMobileScreen}
        px={isMobileScreen && 0}
        style={{
          overflow: "hidden",
          marginTop: isMobileScreen ? "150px" : "170px",
        }}
      >
        {/* Breadcrumbs */}
        <Box mb={isMobileScreen ? 14 : 24} px={10}>
          <Breadcrumbs separator="/">
          <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
            <Text size={14} color="dimmed">
              Home
            </Text>
            </Link>
            <Text size={14}>Notify</Text>
          </Breadcrumbs>
        </Box>

        {/* Heading */}
        <Box p={10}>
          <Flex align={"center"} justify={"space-between"}>
            <Text size={"xl"} mb={20} fw={600}>
              Notify List
            </Text>
          </Flex>

          {/* Table like cart page */}
<Paper mt={10} p={18} w={"100%"} radius={"sm"}>
  <table width="100%" style={{ borderCollapse: "collapse" }}>
{!isMobileScreen && (
  <thead>
    <tr style={{ borderBottom: "1px solid #eee" }}>
      <th align="left" style={{ padding: "10px" }}>S.No</th>
      <th align="left" style={{ padding: "10px" }}>Product</th>
      <th align="left" style={{ padding: "10px" }}>Price</th>
      <th align="left" style={{ padding: "10px" }}>Status</th>
      <th align="center" style={{ padding: "10px" }}>Add To Cart</th>
      <th align="center" style={{ padding: "10px" }}></th>
    </tr>
  </thead>
)}

<tbody>
  {notifyList.map((item, index) => (
    isMobileScreen ? (
      // ✅ Mobile View - Card Style (with headings inside card)
      <tr key={item.id}>
        <td colSpan={5} style={{ padding: "12px" }}>
          <Paper shadow="xs" radius="md" p="md" withBorder>
            
            {/* Serial + Delete */}
            <Flex justify="space-between" align="center" mb={8}>
              <Text fw={600}>{index + 1}</Text>
              <ActionIcon
                color="red"
                onClick={() => handleDelete(item.id)}
              >
                <IconTrash size={14} />
              </ActionIcon>
            </Flex>

            {/* Product */}
            <Text size="sm" fw={600} mb={6}>
              Product: <span style={{ fontWeight: "normal" }}>{item.product_title}</span>
            </Text>

            {/* Price */}
            <Text size="sm" mb={6}>
              Price:{" "}
              <span style={{ textDecoration: "line-through", color: "grey", marginRight: "5px" }}>
                ₹ {item.mrp}
              </span>
              <span style={{ fontWeight: "600" }}>₹ {item.selling_price}</span>
            </Text>

            {/* Status */}
            <Text size="sm" mb={6}>
              Status:{" "}
              <span style={{ color: item.status === "Notified" ? "red" : "green" }}>
                {item.status}
              </span>
            </Text>

            {/* Add to Cart */}
          <Flex justify="flex-end" mt={8}>
            <ActionIcon
              disabled={item.stock_qty <= 0 || item.status === "Notified"}
              color={item.stock_qty > 0 && item.status === "Available" ? "blue" : "gray"}
              onClick={() => {
                if (item.stock_qty > 0 && item.status === "Available") {
                  addToCart(item);
                }
              }}
            >
              <IconShoppingCart size={16} />
            </ActionIcon>
          </Flex>

          </Paper>
        </td>
      </tr>
    ) : (
      // ✅ Web View - Table
      <tr key={item.id} style={{ borderBottom: "1px solid #eee" }}>
        <td style={{ padding: "12px" }}>{index + 1}</td> {/* Serial Number */}
        <td style={{ padding: "12px" }}>{item.product_title}</td>
        <td style={{ padding: "12px" }}>
          <span style={{ textDecoration: "line-through", color: "grey", marginRight: "5px" }}>
            ₹ {item.mrp}
          </span>
          <span style={{ fontWeight: "600" }}>₹ {item.selling_price}</span>
        </td>
        <td style={{ padding: "12px" }}>
          <span style={{ color: item.status === "Notified" ? "red" : "green" }}>
            {item.status}
          </span>
        </td>
        <td align="center" style={{ padding: "12px" }}>
          <ActionIcon
            disabled={item.stock_qty <= 0 || item.status === "Notified"} // disable if no stock OR notified
            color={item.stock_qty > 0 && item.status === "Available" ? "blue" : "gray"}
            onClick={() => {
              if (item.stock_qty > 0 && item.status === "Available") {
                addToCart(item);
              }
            }}
          >
            <IconShoppingCart size={16} />
          </ActionIcon>
        </td>
        <td align="center" style={{ padding: "12px" }}>
          <ActionIcon
            color="red"
            onClick={() => handleDelete(item.id)}
          >
            <IconTrash size={14} />
          </ActionIcon>
        </td>
      </tr>
    )
  ))}
</tbody>

  </table>
</Paper>
        </Box>
      </Container>
    </div>
  );
}
